export class FAQForm{
    faqFormID!: number;
    itemTypeID!: number;
    itemType!: string;
    item!: string;
    itemID!: number;
    title!: string;
    description!: string;
    notes!: string;
    displayOrder!: number;
    active!: number;
}